const languages = [
    {
        "id": "EN",
        "language": "English",
        "nativeWriting": "English"
    }, {
        "id": "FR",
        "language": "French",
        "nativeWriting": "Français"
    },
    {
        "id": "RU",
        "language": "Russian",
        "nativeWriting": "Русский"
    },
    {
        "id": "ZH-CN",
        "language": "Chinese (Simplified)",
        "nativeWriting": "中文简体"
    },
    {
        "id": "ZH-TW",
        "language": "Chinese (Traditional)",
        "nativeWriting": "中文繁體"
    },
    {
        "id": "KK",
        "language": "Kazakh",
        "nativeWriting": "Қазақ"
    },
    {
        "id": "KO",
        "language": "Korean",
        "nativeWriting": "한국어"
    },
    {
        "id": "ES",
        "language": "Spanish",
        "nativeWriting": "Español"
    },
    {
        "id": "TH",
        "language": "Thai",
        "nativeWriting": "ไทย"
    },
    {
        "id": "TR",
        "language": "Turkish",
        "nativeWriting": "Türk"
    },
    {
        "id": "VI",
        "language": "Vietnamese",
        "nativeWriting": "Tiếng Việt"
    },
    {
        "id": "UK",
        "language": "Ukrainian",
        "nativeWriting": "Українська"
    },
    {
        "id": "PT",
        "language": "Portuguese",
        "nativeWriting": "Português"
    },
    {
        "id": "IT",
        "language": "Italian",
        "nativeWriting": "Italiano"
    },
    {
        "id": "JA",
        "language": "Japanese",
        "nativeWriting": "日本語"
    }
]



export default languages;